import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';
import AuthModal from './auth/AuthModal';
import LandingPageContent from './landing/LandingPageContent';
import PolicyModal from './orders/PolicyModal';
import OfertaModal from './orders/OfertaModal';

function Home() {
  const { currentUser, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showOferta, setShowOferta] = useState(false);
  const [showReferral, setShowReferral] = useState(false);

  useEffect(() => {
    if (!loading && currentUser) {
      navigate('/dashboard', { replace: true });
    }
  }, [currentUser, navigate, loading]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referrer_code = params.get('ref');
    const offer_id = params.get('ofid');

    const hasRefCookie = document.cookie
      .split('; ')
      .some((c) => c.startsWith('referrer_code='));

    const hasOfferCookie = document.cookie
      .split('; ')
      .some((c) => c.startsWith('offer_id='));

    if (referrer_code && !hasRefCookie) {
      document.cookie = `referrer_code=${referrer_code}; path=/; max-age=2592000; domain=.pulseads.ru`;
    }

    if (offer_id && !hasOfferCookie) {
      document.cookie = `offer_id=${offer_id}; path=/; max-age=2592000; domain=.pulseads.ru`;
    }
  }, []);

  const openLogin = () => {
    setIsRegistering(false);
    setShowAuthModal(true);
  };

  const openRegister = () => {
    setIsRegistering(true);
    setShowAuthModal(true);
  };

  return (
    <div className="landingRoot">
      <LandingPageContent
        onLogin={openLogin}
        onRegister={openRegister}
        onOpenOferta={() => setShowOferta(true)}
        onOpenPolicy={() => setShowPolicy(true)}
        onOpenReferral={() => setShowReferral(true)}
        showReferral={showReferral}
        onCloseReferral={() => setShowReferral(false)}
      />

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        isRegistering={isRegistering}
        setIsRegistering={setIsRegistering}
      />

      <PolicyModal isOpen={showPolicy} onClose={() => setShowPolicy(false)} />
      <OfertaModal isOpen={showOferta} onClose={() => setShowOferta(false)} />
    </div>
  );
}

export default Home;
